import Root from '@/components/BasicLayout.vue'

// 白名单路由
export default [
  {
    path: '/',
    name: 'index',
    meta: {
      alias: '新财董并购互联 是一款专注于并购服务的一站式并购资源平台'
    },
    component: () => import('@/views/index/index.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      alias: '公司介绍'
    },
    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/aboutUs/index.vue')
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    meta: {
      alias: '加入我们'
    },
    component: () => import(/* webpackChunkName: "joinUs" */ '../views/joinUs/index.vue')
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    meta: {
      alias: '业务合作'
    },
    component: () => import(/* webpackChunkName: "cooperation" */ '../views/cooperation/index.vue')
  },
  {
    path: '/downloadApp',
    name: 'downloadApp',
    meta: {
      alias: '下载App'
    },
    component: () => import(/* webpackChunkName: "project" */ '../views/downloadApp/index.vue')
  },
  {
    path: '/project',
    name: 'project',
    meta: {
      alias: '项目库'
    },
    component: () => import(/* webpackChunkName: "project" */ '../views/project/index.vue')
  },
  {
    path: '/share',
    name: 'share',
    meta: {
      alias: '打开小程序'
    },
    component: () => import('@/views/H5/share.vue')
  },
  {
    path: '/certificationSuccess',
    name: 'certificationSuccess',
    meta: {
      alias: '认证信息'
    },
    component: () =>
      import(/* webpackChunkName: "certificationSuccess" */ '../views/H5/certificationSuccess.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      alias: '注册'
    },
    component: () => import(/* webpackChunkName: "register" */ '../views/H5/register.vue')
  },
  {
    path: '/selectIdentity',
    name: 'selectIdentity',
    meta: {
      alias: '请选择身份'
    },
    component: () =>
      import(/* webpackChunkName: "selectIdentity" */ '../views/H5/selectIdentity.vue')
  },
  {
    path: '/buyerRegister',
    name: 'buyerRegister',
    meta: {
      alias: '买方注册'
    },
    component: () => import(/* webpackChunkName: "buyerRegister" */ '../views/H5/buyerRegister.vue')
  },
  {
    path: '/sellerRegister',
    name: 'sellerRegister',
    meta: {
      alias: '卖方注册'
    },
    component: () =>
      import(/* webpackChunkName: "sellerRegister" */ '../views/H5/sellerRegister.vue')
  },
  {
    path: '/thirdRegister',
    name: 'thirdRegister',
    meta: {
      alias: '第三方注册'
    },
    component: () => import(/* webpackChunkName: "thirdRegister" */ '../views/H5/thirdRegister.vue')
  },
  {
    path: '/underReview',
    name: 'underReview',
    meta: {
      alias: '会员信息审核中'
    },
    component: () => import(/* webpackChunkName: "underReview" */ '../views/H5/underReview.vue')
  },
  {
    path: '/submitResult',
    name: 'submitResult',
    meta: {
      alias: '提交页'
    },
    component: () => import(/* webpackChunkName: "submitResult" */ '../views/H5/submitResult.vue')
  },
  {
    path: '/advertisementDetails',
    name: 'advertisementDetails',
    meta: {
      alias: '广告页和详情'
    },
    component: () =>
      import(/* webpackChunkName: "advertisementDetails" */ '../views/H5/advertisementDetails.vue')
  },
  {
    path: '/progressAndProjectRevenue',
    name: 'progressAndProjectRevenue',
    meta: {
      alias: '项目分成与进展'
    },
    component: () =>
      import(
        /* webpackChunkName: "progressAndProjectRevenue" */ '../views/H5/progressAndProjectRevenue.vue'
      )
  },
  {
    path: '/informationEntry',
    name: 'informationEntry',
    meta: {
      alias: '并购信息录入'
    },
    component: () =>
      import(/* webpackChunkName: "informationEntry" */ '../views/H5/informationEntry.vue')
  },
  {
    path: '/demand',
    name: 'demand',
    meta: {
      alias: '并购信息录入—并购需求'
    },
    component: () => import(/* webpackChunkName: "demand" */ '../views/H5/demand.vue')
  },
  {
    path: '/subjectMatter',
    name: 'subjectMatter',
    meta: {
      alias: '并购信息录入—并购标的'
    },
    component: () => import(/* webpackChunkName: "subjectMatter" */ '../views/H5/subjectMatter.vue')
  },
  {
    path: '/exception/404',
    name: '404',
    meta: {
      alias: '页面不存在'
    },
    component: () => import('../views/exception/404.vue')
  }
]
